import React from 'react';

export default function PlayIcon() {
  return (
    <svg width={12} height={14} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 7 .75 13.495V.505L12 7Z" fill="#0A0A0A" />
    </svg>
  );
}
